import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import translations from '../translations';
import netscoutLogo from '../assets/netscout.svg';

const Partners = () => {
  const { lang } = useLanguage();
  const t = translations[lang];
  const isRTL = lang === 'ar';

  const partners = [
    {
      name: t.partner_itpc_name,
      role: t.partner_itpc_role,
      logo: null,
      url: 'https://itpc.gov.iq',
    },
    {
      name: t.partner_netscout_name,
      role: t.partner_netscout_role,
      logo: netscoutLogo,
      url: 'https://www.netscout.com',
    },
  ];

  return (
    <section className="bg-[#1a2530] py-20 md:py-28 px-6" id="partners" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className={`max-w-6xl mx-auto text-center ${isRTL ? 'font-arabic' : ''}`}>
        <motion.h2
          className="text-[#97d700] text-4xl font-bold font-magistral mb-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          {t.partners_title}
        </motion.h2>
        <div className="w-16 h-1 bg-[#97d700] mx-auto mb-6" />
        <motion.p
          className="text-gray-300 text-base md:text-lg mb-12 md:mb-16 max-w-2xl mx-auto leading-[1.9]"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          {t.partners_subtitle}
        </motion.p>
        <div className="grid md:grid-cols-2 gap-12 max-w-4xl mx-auto items-center">
          {partners.map((partner, i) => (
            <motion.a
              key={partner.name}
              href={partner.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center p-8 rounded-xl bg-[#111820]/50 border border-white/5 hover:border-[#97d700]/30 hover:bg-[#111820]/70 transition-all duration-300 cursor-pointer group"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
            >
              {partner.logo ? (
                <img
                  src={partner.logo}
                  alt={`${partner.name} logo`}
                  className="h-20 mb-6 object-contain group-hover:scale-105 transition-transform duration-300"
                />
              ) : (
                <div className="h-20 mb-6 flex items-center justify-center">
                  <span className="text-white text-2xl font-bold font-magistral group-hover:text-[#97d700] transition-colors duration-300">ITPC</span>
                </div>
              )}
              <h3 className="text-white text-xl font-bold mb-2 group-hover:text-[#97d700] transition-colors duration-300">{partner.name}</h3>
              <p className="text-gray-300 leading-[1.9]">{partner.role}</p>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
